import { useEffect, useState } from 'react';
import { referenceService } from 'src/api/references/referenceService';
import ByzMuiTypography from 'src/components/core-components/mui/inputs/ByzMuiTypography';
import { useTranslate } from 'src/locales';

let cachedNote: string | null = null;

function EdineburghDeptScaleFooter() {
  const { t } = useTranslate();
  const [note, setNote] = useState<string>(cachedNote || "");

  useEffect(() => {
    if (cachedNote !== null) return;

    const fetchData = async () => {
      try {
        const response = await referenceService.card.getCardTableData({
          tableName: "MC_PARAMETERS",
          columnName: "ID",
          columnValue: 606,
        });

        if (response.data && response.data.length > 0) {
          const row = response.data[0] as any;
          const fetchedNote = row.NOTE || row.note || "";
          cachedNote = fetchedNote;
          setNote(fetchedNote);
        }
      } catch (error) {
        console.error("Error fetching footer note:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {note && <ByzMuiTypography style={{ whiteSpace: "pre-wrap", fontSize: "14px" }}>{note}</ByzMuiTypography>}
    </>
  )
}

export default EdineburghDeptScaleFooter